module.exports = __webpack_public_path__ + "static/media/kids-main-image.97e5ec4f.png";